// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/credit-card.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/credit-card'

import { Icon, type IconComponentProps } from '../icon'

export const CreditCardIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
